<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="matches.length == 0">
        <p>No result data found.</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive">
            <div class="match-table result-table">
                <h2 class="text-uppercase">{{ global.Components['teamDetail'].tournament.name }}</h2>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-for="match in matches" :key="match.id">
                            <div class="td">{{ match.gmt_datetime | formatDate('MMM YYYY') }}</div>
                            <div class="td">
                                <span class="title">
                                    {{ isTeam1Active(match) ? match.team1.name : match.team2.name }}
                                </span>
                                <span class="sub-title">
                                    {{ ! isTeam1Active(match) ? match.team1.name : match.team2.name }}
                                </span>
                            </div>
                            <div class="td">
                                <span class="title">{{ isTeam1Active(match) ? match.ht_score : match.at_score }}</span>
                                <span class="sub-title">{{ ! isTeam1Active(match) ? match.ht_score : match.at_score }}</span>
                            </div>
                            <div class="td">
                                <span class="circle" :class="{red: getResults(match)=='L', orange: getResults(match)=='D'}">
                                      {{ getResults(match) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'teamResults',

        data() {
            return {
                matches: []
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TEAM_RESULTS_API.replace(':tournament', this.$route.params.tournament).replace(':team', this.$route.params.team))
                        .then(response => {
                            this.is_data_ready = true
                            this.matches = response.data.result.matches || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            isTeam1Active(match) {
                return Components['teamDetail'].team.id == match.team1.id
            },

            getResults(match) {
                if (match.winner == 3) {
                    return 'D'
                }
                if (this.isTeam1Active(match)) {
                    if (match.winner == 1)
                        return 'W'
                    return 'L'
                } else {
                    if (match.winner == 2)
                        return 'W'
                    return 'L'
                }
            }
        }
    }
</script>
